import { useState, useEffect } from 'react';

export default function useProgress() {
  const [completed, setCompleted] = useState(() => {
    // FIX: guard against SSR where window/localStorage don't exist
    try {
      if (typeof window === 'undefined') return {};
      const saved = localStorage.getItem('ts_progress');
      return saved ? JSON.parse(saved) : {};
    } catch {
      return {};
    }
  });

  // Persist to localStorage whenever completed changes
  useEffect(() => {
    try {
      localStorage.setItem('ts_progress', JSON.stringify(completed));
    } catch {
      // localStorage might be blocked (private browsing etc.) — fail silently
    }
  }, [completed]);

  function markDone(moduleId, lessonId) {
    const key = `${moduleId}-${lessonId}`;
    setCompleted(prev => ({ ...prev, [key]: true }));
  }

  function isDone(moduleId, lessonId) {
    return !!completed[`${moduleId}-${lessonId}`];
  }

  function getModuleProgress(moduleId, totalLessons) {
    let count = 0;
    for (let i = 1; i <= totalLessons; i++) {
      const lesId = String(i).padStart(2, '0');
      if (completed[`${moduleId}-${lesId}`]) count++;
    }
    return count;
  }

  function getTotalProgress(curriculum) {
    let done = 0;
    let total = 0;
    Object.entries(curriculum).forEach(([modId, mod]) => {
      Object.keys(mod.lessons).forEach(lesId => {
        total++;
        if (completed[`${modId}-${lesId}`]) done++;
      });
    });
    return { done, total };
  }

  return { completed, markDone, isDone, getModuleProgress, getTotalProgress };
}